<template>
  <section>

    <!-- 多选上传图片 -->
    <div v-if="imgs.length != 0" class="m-imgs-wrapper">
      <div class="imgs-box" v-for="(it,index) in imgs" :key="index">
        <img :src="it.url"  :style="{'width':width+'px', 'height':height+'px'}" class="img"  alt="img">
        <div class="imgs-hover">
          <i class="el-icon-delete"  @click="handleDelete(it.pic_id,index)"></i>
        </div>
      </div>
        
    </div>
      
    <label v-show="max == 0 || imgs.length < max" :style="{'width':width+'px', 'height':height+'px',}"  class="input-label" v-loading="loading">
      <i class="el-icon-plus upload-icon"></i>
      <input @change="handleChange($event)" type="file" accept=".jpg,jpeg,.png" multiple="multiple" style="display:none">
    </label>

    <!-- 放大显示图片 -->
    <el-dialog :visible.sync="zoom_bol" center append-to-body width="550px">
        <img width="500px" :src="zoom_src" alt="img">
    </el-dialog>

  </section>
</template>

<script>
import { post } from '@/untils/axios.js'

export default {
  name:"Upload",
  props:{
    url:{
      type:String,
      default:'',
      required:true
    },
    delUrl:{
      type:String,
      default:'',
      required:true
    },
    fileName:{
      type:String,
      default:'',
      required:true,
    },
    width:{
      type:Number,
      default:178
    },
    height:{
      type:Number,
      default:178
    },
    max:{
      type:Number,
      default:0,
    },
    // 清空内容  0 不清空；1 提交成功之后清空； 2 未提交页面发生改变 需要删除当前上传的参数；
    clear:{
      type:Number,
      default:0, 
    }
  },
  data(){
    return {
      imgs:[],
      zoom_bol:false,
      zoom_src:'',
      loading: false,
    }
  },
  methods:{
    handleChange(e){
      let files = Array.from(e.target.files);
      var image = new FormData()
      image.append('filename', this.fileName)

      files.forEach( (e,index) => {
        image.append(`file[${index}]`, e)
      })
      this.loading = true
      post(this.url,image).then(res => {
        if(res){
          this.imgs    = [...this.imgs, ...res.data]
          this.imgs.reverse()
          this.$emit('success',res)
         
        }
      }).finally( () => {
        this.loading = false
      })


    },
    // 放大图片
    handleZoom(it){
      this.zoom_src = it
      this.zoom_bol = true
    },
    // 删除图片
    handleDelete(it,index){
      let url = `${this.delUrl}/${it}`
      post(url).then( () => {
        this.imgs.splice(index, 1)
        this.clear  = 0
        this.pic_id = ''
      })
    }
  },
}
</script>

<style lang="less" scoped>
section{
  .m-imgs-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .imgs-box {
      height: 178px;
      margin-bottom: 8px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      border-radius:5px ;
      position: relative;
      &:not(:first-child){
        margin-left: 8px;
      }
      &:hover{
        .imgs-hover {
          opacity:1;
        }
      }
      .imgs-hover {
        opacity: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,.5);
        transition: opacity .3s;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        &>i {
          font-size: 20px;
          &:not(:first-child){
            margin-left: 8px;
          }
        }
      }
    }
  }
  .input-label {
    display: flex;
    border: 1px dashed #d9d9d9;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
  }
  .input-label:hover{
    border-color:#409EFF ;
  }
  .upload-icon {
    font-size: 28px;
    color: #8c939d;
  }
}
</style>